// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__31ROZ","row":"Node_row__3FRdL","label":"Node_label__1mGrB","footer":"Node_footer__3Q8N_"};